import React from 'react';
import styles from './DispatchComplianceTable.module.css';

export default function DispatchComplianceTable({ data }) {
  const getColomnColor = (value) => {
    if (value < 80) return styles.red;
    if (value < 95) return styles.yellow;
    return styles.green;
  };

  return (
    <div className={`${styles.container} no-scrollbar`}>
      <div className={styles.columnHeader}>
        <div className={styles.emptyCell}></div>
        <div className={styles.headerCell}>24 <br /> Hrs</div>
        <div className={styles.headerCell}>48 <br /> Hrs</div>
      </div>

      {data.map((item, index) => (
        <div key={index} className={styles.dataColumn}>
          {item.isCurrent && (
            <>
              <div className={styles.dotWrapper}>
                <div className={styles.dot}></div>
              </div>
              <div className={styles.gradientOverlay}></div>
            </>
          )}

          <div className={styles.dayCell}>{item.day}</div>
          <div className={styles.valueCell}>
            <span className={`${styles.valueText} ${getColomnColor(Number(item.hrs24))}`}>{item.hrs24}%</span>
          </div>
          <div className={styles.valueCell}>
            <span className={`${styles.valueText} ${getColomnColor(Number(item.hrs48))}`}>{item.hrs48}%</span>
          </div>
        </div>
      ))}
    </div>
  );
}